<template>
    <div>
        <header>
            <nav class="navbar navbar-expand-md fixed-top navbar-dark bg-dark">
                <!-- aca ira el menu -->
                <!-- Brand -->
                <a class="navbar-brand" href="#">
                    <img src="@/assets/images/logo_limpio.png" width="70" height="60" class="d-inline-block align-top" alt=""/>
                </a>
                <!-- Toggler/collapsibe Button -->
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
                    <span class="navbar-toggler-icon"></span>
                </button>

                    <transition name="fade">
                            <!-- <nav-bar v-if="cUserSession.role" :guest=guest :admin=admin :user=user></nav-bar> -->
                            <nav-bar :guest=guest :admin=admin :oper=oper :finance=finance :security=security :supadmin=supadmin :enrollment=enrollment :capitanias=capitanias :uumm=uumm></nav-bar>
                    </transition>
                <!-- Navbar links -->
            </nav>
        </header>
        <br>
        <br>
        <br>
        <br>
        <main role="main" class="container-fluid">
            
            <transition name="fade" mode="out-in">
                <router-view></router-view>
            </transition>
        </main>
        <br>
        <footer class="footer navbar-fixed-bottom bg-dark d-print-none" style="z-index:-999;">
            <div class="container" >
                <transition name="fade">
                    <span class="text-muted d-none d-sm-block" v-if="cUserSession.nick" > SIIDCAP - Usuario: {{ cUserSession.nick }} | Capitania: {{ cUserSession.name_port }} ©DGCP - NP. Ronald Portocarrero Ulloa</span>              
                </transition>
                <transition name="fade">
                    <span class="text-muted d-block d-sm-none" v-if="cUserSession.nick">Usuario: {{ cUserSession.nick }} | Dependencia: {{ cUserSession.name_port }}</span>
                </transition>
                
            </div>
        </footer>        
    </div>

</template>
<script>

import Vue from 'vue'
import Navbar from './Navbar'
import MenuCentral from './MenuCentral'

import axios from 'axios'
// cotizacion
import SearchBoat from '../cotizacion/searchBoat'
import BoatRegister from '../cotizacion/boatRegister'



export default {
    name:'dashboard',
    data(){
        return{
            role:0,
            guest:false,
            admin:false,
            oper:false,
            finance:false,
            security:false,
            supadmin:false,
            enrollment:false,
            capitanias:false,
            uumm:false,
            roleAssign:null,
        }
    },
    mounted(){
        // if(Vue.auth.getToken()){
        //     axios.defaults.headers.common['Authorization']=`Bearer ${Vue.auth.getToken()}`;  
        // }
        
        this.callUfv(),
        this.callDtsUser()
    },
    methods:{
        loadMenu(){
            switch(this.roleAssign){
                case 'CAPITANIAS':
                    if(this.role===392){
                        this.capitanias=true;
                    }else{
                        this.guest=true;
                    }
                break;

                case 'GERENCIAL':
                    if(this.role===390){
                        this.admin=true;
                    }else{
                        this.guest=true;
                    }
                    
                break;

                case 'OPERADOR CAPITANIA':
                    if(this.role===4){
                        this.oper=true;
                    }else{
                        this.guest=true;
                    }
                    
                break;

                case 'FINANCIERO':
                    if(this.role===388){
                        this.finance=true;
                    }else{
                        this.guest=true;
                    }
                    
                break;

                case 'SEGURIDAD':
                    if(this.role===389){
                        this.security=true;
                    }else{
                        this.guest=true;
                    }
                    
                break;

                case 'SUPER ADMINISTRADOR':
                    if(this.role===3){
                        this.supadmin=true;
                        
                    }else{
                        this.guest=true;
                    }                    
                break;

                case 'MATRICULACION':
                    if(this.role===391){
                        this.enrollment=true;
                        
                    }else{
                        this.guest=true;
                    }                    
                break;

                case 'MARINA MERCANTE':
                    if(this.role===530){
                        this.uumm=true;
                        
                    }else{
                        this.guest=true;
                    }
                break;

                default:
                    this.guest=true;
                break;
            }
        },
        callUfv(){
            // axios.get(`ufv`)
            axios.get(`ufv?api_token=${Vue.auth.getToken()}`)
            .then(res => {
                this.$store.dispatch('addUFV', res.data[0].value);
            })
        },
        callDtsUser(){
            // axios.get('dtsUser')
            axios.get(`dtsUser?api_token=${Vue.auth.getToken()}`)
            .then(res=>{
                this.$store.dispatch('sessionInit', res.data[0]);
                this.role=this.cUserSession.role;
                this.roleAssign=this.cUserSession.roleAssign;
                // console.log(`el usuario es ${this.roleAssign} con ${this.role}`);
                this.loadMenu();
            })
        }
    },
    computed:{
        cUserSession(){
            // console.log(this.$store.getters.getUserState);
            return this.$store.getters.getUserState;           
        }
    },
    components:{
        'nav-bar':Navbar,
        'search-boat':SearchBoat,
        'boat-register':BoatRegister,
        'menu-central':MenuCentral
    }
}


</script>


<style>
@media (min-width: 768px) {
    .navImg {
        margin-top: -15px;
        z-index: 30;
        position: fixed;
    }    
}



.backgroundForm{
    background: #fff;
    padding-bottom: 15px;
    padding-top: 10px;
    border-radius: 10px;
}
.labelBlack{
    font-weight: bold;
}


</style>



// WEBPACK FOOTER //
// src/components/dashboard/Dashboard.vue